import styled from 'styled-components';

export const ReviewsTabSection = styled.section`
     
`;

export const FundraiserTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: 700;
    line-height: 58px;
    margin-bottom: 30px;     

    @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
    }

    @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
    }

    @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
    }
`;

export const ReviewProfile = styled.div`
  display:flex;
  gap:24px;

  @media screen and (max-width:767px){
    gap:24px 20px;
    flex-direction: column;
  }

  @media screen and (max-width:575px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const ProfileImage = styled.div`
  width:100%;
  max-width:282px;
       @media screen and (max-width:991px) {
         width:100%;
  max-width:100%;
       }
`;

export const ReviewText = styled.div`
  width:100%;
  max-width:894px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  
  .review-help {
    display: none;
  }
`;

